import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=27d67ee9"
import script from "./MessageForm.vue?vue&type=script&lang=js"
export * from "./MessageForm.vue?vue&type=script&lang=js"
import style0 from "./MessageForm.vue?vue&type=style&index=0&id=27d67ee9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports